import { OnDataOptions } from '@apollo/client/react/types/types.js'
import { Dispatch, SetStateAction, useCallback } from 'react'
import {
  UpdatedTableRowSubscription,
  useUpdatedTableRowSubscription,
} from '~/common/generated/apollo-operations'
import { DetailedTableRow } from '~/components/tables/types'

interface TableRowChangeSubscriptionProps {
  tableRowId: string
  rowIndex: number
  setRowsData: Dispatch<SetStateAction<DetailedTableRow[]>>
}

/**
 * Function to subscribe to updates to a table row in the DossTable
 */
export function TableRowChangeSubscription({
  tableRowId,
  setRowsData,
}: TableRowChangeSubscriptionProps) {
  const handleRowUpdate = useCallback(
    (options: OnDataOptions<UpdatedTableRowSubscription>) => {
      if (!options.data.data) {
        return
      }

      const updatedTableRow = options.data.data.updatedTableRowDetails

      setRowsData((prevRows) => {
        const rowIndex = prevRows.findIndex((row) => row.id === tableRowId)
        if (rowIndex >= 0) {
          const newRows = [...prevRows]
          newRows[rowIndex] = updatedTableRow
          return newRows
        }
        return prevRows
      })
    },
    [tableRowId, setRowsData],
  )

  useUpdatedTableRowSubscription({
    variables: { tableRowId },
    onData: handleRowUpdate,
  })

  return <></>
}
